import { createAction, props } from '@ngrx/store';
import { IClientSettings } from 'src/app/core/models/agency-settings.model';
import { Location } from 'src/app/core/models/itinerary.model';
import { Airline, Currency, ContractError } from 'src/app/core/models/models';

// Settings

export const LoadClientSettings = createAction(
  '[Settings] Load Client Settings',
  props<{ agencyId: string }>()
);

export const LoadClientSettingsSuccess = createAction(
  '[Settings] Load Client Settings Success',
  props<{ settings: IClientSettings }>()
);

export const GenericError = createAction(
  '[APP] Generic Error',
  props<{ error: ContractError; titleKey?: string }>()
);

// Currencies

export const LoadCurrencies = createAction('[Settings] Load Currencies ');

export const LoadCurrenciesSuccess = createAction(
  '[Settings] Load Currencies Success',
  props<{ currencies: Currency[] }>()
);
